import type { AuditStatus, PipelineStep } from "../lib/types";

interface StepDef {
  key: PipelineStep;
  label: string;
}

const STEPS: StepDef[] = [
  { key: "queued", label: "Queued" },
  { key: "fetching_robots", label: "Checking robots.txt" },
  { key: "rendering_page", label: "Rendering page" },
  { key: "parsing_content", label: "Parsing content" },
  { key: "scoring", label: "Scoring" },
  { key: "done", label: "Done" },
];

interface Props {
  status: AuditStatus;
  step: PipelineStep | null;
}

function stepIndex(step: PipelineStep | null): number {
  if (!step) return 0;
  const idx = STEPS.findIndex((s) => s.key === step);
  return idx < 0 ? 0 : idx;
}

export default function ProgressSteps({ status, step }: Props) {
  const active = stepIndex(step);
  const finished = status === "complete";
  const failed = status === "failed";
  return (
    <ol className="space-y-3">
      {STEPS.map((s, i) => {
        const done = finished || i < active;
        const current = !finished && !failed && i === active;
        return (
          <li key={s.key} className="flex items-center gap-3">
            <span
              className={`flex h-7 w-7 items-center justify-center rounded-full border text-sm font-medium ${
                done
                  ? "bg-green-600 border-green-600 text-white"
                  : current
                    ? "bg-cyan-600 border-cyan-600 text-white"
                    : "border-ink-200 text-ink-400"
              }`}
              aria-hidden
            >
              {done ? "✓" : i + 1}
            </span>
            <span
              className={`${
                done ? "text-ink-900" : current ? "text-ink-900 font-medium" : "text-ink-400"
              }`}
            >
              {s.label}
            </span>
            {current && (
              <span
                className="ml-2 inline-block h-2 w-2 animate-pulse rounded-full bg-cyan-500"
                aria-hidden
              />
            )}
          </li>
        );
      })}
    </ol>
  );
}
